import { render } from "./BranchCommunication.vue?vue&type=template&id=06802e0a&scoped=true"
import script from "./BranchCommunication.vue?vue&type=script&lang=js"
export * from "./BranchCommunication.vue?vue&type=script&lang=js"

import "./BranchCommunication.vue?vue&type=style&index=0&id=06802e0a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06802e0a"]])

export default __exports__